function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var GuamFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: "24",
    height: "18",
    x: "0",
    y: "3",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#C51918",
      fillRule: "evenodd",
      d: "M0 3h24v18H0V3Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#4564F9",
      fillRule: "evenodd",
      d: "M3 6h18v12H3V6Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "#CBDAFF",
      strokeOpacity: ".1",
      d: "M3.5 6.5h17v11h-17v-11Z"
    }), /*#__PURE__*/_jsxs("mask", {
      id: "b",
      width: "18",
      height: "12",
      x: "3",
      y: "6",
      maskUnits: "userSpaceOnUse",
      style: {
        maskType: 'luminance'
      },
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M3 6h18v12H3V6Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        stroke: "#fff",
        d: "M3.5 6.5h17v11h-17v-11Z"
      })]
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#b)",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#CCE0E5",
        fillRule: "evenodd",
        d: "M12 6s4.5 2.172 4.5 5.788C16.5 15.405 12 18 12 18s-4.5-2.697-4.5-6.212C7.5 8.273 12 6 12 6Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        stroke: "#C1C9F1",
        strokeOpacity: ".148",
        strokeWidth: "1.45",
        d: "m12 6 .315-.653-.322-.156-.32.162L12 6Zm0 0 .316-.653.002.001.004.002.013.007a3.732 3.732 0 0 1 .203.105 12.103 12.103 0 0 1 2.192 1.532c1.182 1.046 2.495 2.675 2.495 4.794 0 2.106-1.3 3.837-2.468 4.98a13.764 13.764 0 0 1-2.332 1.823c-.019.01-.033.02-.044.026l-.013.007-.004.003h-.001L12 18m0-12-.327-.647-.002.001-.004.002-.013.007a4.702 4.702 0 0 0-.202.11 12.691 12.691 0 0 0-2.186 1.564c-1.174 1.05-2.491 2.68-2.491 4.751 0 2.058 1.303 3.79 2.465 4.94a14.454 14.454 0 0 0 2.325 1.855l.044.027.012.008.004.003h.001L12 18m0 0 .362.628-.37.213-.365-.22L12 18Z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#CCE0E5",
        d: "m12.3 7.528.343-.639-.351-.189-.348.196.356.632Zm0 0 .344-.639.002.001.003.002.01.006.032.018.112.065a8.416 8.416 0 0 1 1.506 1.172c.812.8 1.716 2.05 1.716 3.673 0 1.61-.893 2.934-1.69 3.803a9.689 9.689 0 0 1-1.597 1.389l-.031.02-.01.007-.003.002h-.001v.001l-.393-.61m0-8.91-.356-.632-.002.001-.003.002-.01.005-.032.02a7.899 7.899 0 0 0-.485.317 8.836 8.836 0 0 0-1.124.944c-.805.803-1.713 2.053-1.713 3.64 0 1.577.896 2.9 1.688 3.773a10.204 10.204 0 0 0 1.589 1.412l.031.022.01.006.002.002h.002v.001l.403-.603m0 0 .392.61-.4.257-.394-.264.402-.603Z"
      }), /*#__PURE__*/_jsx("path", {
        stroke: "#C1C9F1",
        strokeOpacity: ".748",
        strokeWidth: "1.45",
        d: "m12.3 7.528.343-.639-.351-.189-.348.196.356.632Zm0 0 .344-.639.002.001.003.002.01.006.032.018.112.065a8.416 8.416 0 0 1 1.506 1.172c.812.8 1.716 2.05 1.716 3.673 0 1.61-.893 2.934-1.69 3.803a9.689 9.689 0 0 1-1.597 1.389l-.031.02-.01.007-.003.002h-.001v.001l-.393-.61m0-8.91-.356-.632-.002.001-.003.002-.01.005-.032.02a7.899 7.899 0 0 0-.485.317 8.836 8.836 0 0 0-1.124.944c-.805.803-1.713 2.053-1.713 3.64 0 1.577.896 2.9 1.688 3.773a10.204 10.204 0 0 0 1.589 1.412l.031.022.01.006.002.002h.002v.001l.403-.603m0 0 .392.61-.4.257-.394-.264.402-.603Z"
      }), /*#__PURE__*/_jsx("path", {
        stroke: "#C51918",
        strokeWidth: "1.45",
        d: "m12.3 7.528.343-.639-.351-.189-.348.196.356.632Zm0 0 .344-.639.002.001.003.002.01.006.032.018.112.065a8.416 8.416 0 0 1 1.506 1.172c.812.8 1.716 2.05 1.716 3.673 0 1.61-.893 2.934-1.69 3.803a9.689 9.689 0 0 1-1.597 1.389l-.031.02-.01.007-.003.002h-.001v.001l-.393-.61m0-8.91-.356-.632-.002.001-.003.002-.01.005-.032.02a7.899 7.899 0 0 0-.485.317 8.836 8.836 0 0 0-1.124.944c-.805.803-1.713 2.053-1.713 3.64 0 1.577.896 2.9 1.688 3.773a10.204 10.204 0 0 0 1.589 1.412l.031.022.01.006.002.002h.002v.001l.403-.603m0 0 .392.61-.4.257-.394-.264.402-.603Z"
      }), /*#__PURE__*/_jsxs("mask", {
        id: "c",
        width: "7",
        height: "10",
        x: "9",
        y: "7",
        maskUnits: "userSpaceOnUse",
        style: {
          maskType: 'luminance'
        },
        children: [/*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M12.319 15.527a1.32 1.32 0 0 0-.013.01l-.018-.015a8.771 8.771 0 0 1-.951-.898c-.708-.781-1.312-1.764-1.312-2.798 0-1.022.592-1.921 1.287-2.615a7.392 7.392 0 0 1 .995-.827l.051.035c.256.176.596.435.933.767.688.678 1.284 1.577 1.284 2.64 0 1.074-.607 2.057-1.31 2.823a8.247 8.247 0 0 1-.946.878Zm-.363-7.361Z"
        }), /*#__PURE__*/_jsx("path", {
          stroke: "#fff",
          strokeWidth: "1.45",
          d: "M12.319 15.527a1.32 1.32 0 0 0-.013.01l-.018-.015a8.771 8.771 0 0 1-.951-.898c-.708-.781-1.312-1.764-1.312-2.798 0-1.022.592-1.921 1.287-2.615a7.392 7.392 0 0 1 .995-.827l.051.035c.256.176.596.435.933.767.688.678 1.284 1.577 1.284 2.64 0 1.074-.607 2.057-1.31 2.823a8.247 8.247 0 0 1-.946.878Zm-.363-7.361Z"
        })]
      }), /*#__PURE__*/_jsxs("g", {
        mask: "url(#c)",
        children: [/*#__PURE__*/_jsx("path", {
          fill: "#91CBCB",
          d: "M9.7 13.5h5.6v1.125H9.7z"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#FDF9A1",
          fillRule: "evenodd",
          d: "M10.201 14.398s3.97.002 4.336-.135c.365-.137-.685 2.63-2.027 2.63s-2.309-2.495-2.309-2.495Z",
          clipRule: "evenodd"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#A68861",
          d: "m13.945 14.066-.713.55c-1.124-1.462-1.596-2.973-1.394-4.515l.892.116c-.169 1.292.23 2.569 1.215 3.85Z"
        }), /*#__PURE__*/_jsx("path", {
          fill: "#239E46",
          fillRule: "evenodd",
          d: "m12.295 10.227-.714.837c-.017.02-.05.004-.043-.022l.246-1.044H10.66c-.027 0-.035-.037-.01-.048l.964-.423-.673-.886c-.015-.02.006-.048.03-.039l1.056.412.244-.981c.006-.026.042-.026.048 0l.243.981 1.051-.41c.024-.008.045.02.029.04l-.728.883 1.02.423c.025.01.018.048-.01.048h-1.01l.15 1.06c.004.024-.027.038-.044.02l-.725-.85ZM11.7 12.75h3.6v.787h-3.6v-.787Z",
          clipRule: "evenodd"
        })]
      })]
    })]
  })]
}));
//# sourceMappingURL=Guam.js.map